export default __webpack_public_path__ + "static/ban5-3037b4303c255996feaa619c43033340.png";